import { Link } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-6 bg-background-50">
      <span className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-100/40 select-none pointer-events-none z-0">
        404
      </span>
      <div className="relative z-10 max-w-md">
        <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          Page Not Found
        </h1>
        <p className="text-sm text-foreground-600 font-mono mb-1">{location.pathname}</p>
        <p className="text-sm text-foreground-500 mb-8">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors duration-200 whitespace-nowrap"
        >
          <i className="ri-arrow-left-line mr-2"></i>
          Back to Homepage
        </Link>
      </div>
    </div>
  );
}